/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import type { CSSProperties, JSX } from 'react';

interface ProgressBarProps {
  readonly value: number;
}

/** Slim accessible progress bar (0–100). Width is the only dynamic style. */
export function ProgressBar({ value }: ProgressBarProps): JSX.Element {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  const fill: CSSProperties = { width: `${String(clamped)}%` };
  return (
    <div
      className="h-2 w-full overflow-hidden rounded-full bg-slate-100"
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className="h-full rounded-full bg-[var(--accent)]" style={fill} />
    </div>
  );
}
